<template>
  <div v-if="errors.length > 0" class="container error-boxes">
    <article
      class="message is-danger"
      v-for="(error, idx) in errors"
      :key="idx"
    >
      <div class="message-body level">
        <div class="level-left">{{ $t(error) }}</div>
        <div class="level-right">
          <button class="delete level-right" @click="removeError(idx)"></button>
        </div>
      </div>
    </article>
    <div v-if="errors.length > 1" class="errors-footer">
      <span v-if="allErrors.length > errors.length">
        {{ $t("Messages") }}: {{ `${errors.length}/${allErrors.length}` }}
        <a
          class="button is-rounded is-outlined is-small"
          @click="showAll = true"
        >
          <span class="fa fa-angle-double-down" />
          <span>{{ $t("Show All") }}</span>
        </a>
      </span>
      <span class="is-pulled-right">
        <a class="button is-rounded is-outlined is-small" @click="clearErrors">
          <span class="fa fa-angle-double-up" />
          <span>{{ $t("Clear All") }}</span>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { state, actions } from "@/store"

export default {
  name: "error-box",
  data() {
    return {
      showAll: false
    }
  },
  computed: {
    errors() {
      return this.showAll ? this.allErrors : this.allErrors.slice(0, 3)
    },
    allErrors() {
      return state.errors
    }
  },
  methods: {
    removeError(index) {
      actions.removeError(index)
      if (state.errors.length <= 3) {
        this.showAll = false
      }
    },
    clearErrors() {
      this.showAll = false
      actions.clearErrors()
    }
  }
}
</script>

<style lang="scss" scoped>
.error-boxes {
  position: sticky;
  top: 3.25rem;
  z-index: 20;
  background: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  .fa {
    padding-right: 0.5rem;
  }
  .message {
    &:first-child {
      margin-top: 0.5rem;
    }
    margin-bottom: 0.5rem;
  }
  .message-body {
    display: inline-flex;
    width: 100%;
  }
  .level-left + .level-right {
    margin-top: 0;
  }
  .errors-footer {
    overflow: hidden;
    padding-bottom: 0.5rem;
  }
}
</style>
